import theme from '@/styles/theme';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/system';
import { IconLock } from '@mzc-cloudplex/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

// my job(purge/compare) 리스트에서 접근 권한이 없는(403) 항목에 표시하는 인라인 fallback.
// job 목록은 여러 프로젝트의 작업이 섞여 있으므로, 권한 없는 항목만 이 컴포넌트로 대체한다.
const JobItemForbidden = ({ projectId }) => {
  const { t } = useTranslation('jobs');
  return (
    <Box sx={{ paddingBottom: 4 }}>
      <Box
        sx={{
          mt: 1,
          py: 4,
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          backgroundColor: alpha(theme.palette.grayscaleSecondary[50], 0.5),
          borderRadius: '2px'
        }}
      >
        <IconLock size={32} htmlColor={theme.palette.text.secondary} />
        <Typography variant={'body2'} align={'center'}>
          {t('forbiddenJob')}
        </Typography>
        {projectId && (
          <Typography variant={'caption'} color={theme.palette.text.secondary}>
            ({projectId})
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default JobItemForbidden;
